<ion-toolbar [style]="styles">
  <ion-row class="m-bctx-header">
    <div *ngIf="enableBack" class="m-bctx-header__back" (click)="handleBack()">
      <ion-img [src]="backArrow"></ion-img>
    </div>
    <ion-row
      class="m-bctx-header__info"
      [ngStyle]="{
        width: variableGroupFieldsInfo.length === 0 ? '100%' : 'auto'
      }"
    >
      <div *ngFor="let item of bctxHeader" class="item-info">
        <div class="label">{{ item.label | translate }}</div>
        <div class="value" [style.color]="item.textColor">{{ item.value || '--' }}</div>
      </div>
      <div *ngIf="enableSearch">{{ 'input_app_common.search' | translate }}</div>
    </ion-row>
    <div class="divider" *ngIf="variableGroupFieldsInfo.length"></div>
    <div *ngIf="variableGroupFieldsInfo.length" class="m-bctx-header__po-split-identifiers">
      <div *ngFor="let identifier of variableGroupFieldsInfo" class="identifier">
        <div class="po-item">
          <span>{{ identifier.variableFieldName }}</span>
          <span>{{ identifier.currentVariableFieldValue }}</span>
        </div>
        <ion-img [src]="longArrowRight"></ion-img>
        <div class="po-item">
          <span>{{ identifier.variableFieldName }}</span>
          <span>{{ identifier.newVariableFieldValue }}</span>
        </div>
      </div>
    </div>
  </ion-row>
</ion-toolbar>
